import { render, staticRenderFns } from "./CreateWIModal.vue?vue&type=template&id=10698948&scoped=true"
import script from "./CreateWIModal.vue?vue&type=script&lang=js"
export * from "./CreateWIModal.vue?vue&type=script&lang=js"
import style0 from "./CreateWIModal.vue?vue&type=style&index=0&id=10698948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10698948",
  null
  
)

export default component.exports